// services
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';



export const useProjectSGModuleTemplateService = () => {
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const handlerEndpoint = 'projectsg-module-template';

    const getAllProjectSGPartnerModuleTemplate = async (): Promise<any[]> => {
        const res = await axios.get(
            `${apiUrl}/${handlerEndpoint}/type/partner_module`,
        );
        return (res.data||[]);
    };

    const getAllProjectSGDefaultModuleTemplate = async (): Promise<any[]> => {
        const res = await axios.get(
            `${apiUrl}/${handlerEndpoint}/type/default_module`,
        );
        return (res.data||[]);
    };

    const getProjectSGModuleTemplate = async (id): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res.data;
    };

    const getProjectSGModuleTemplateSummaryById = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/summary/${id}`);
        return res.data;
    };


    const getProjectSGCategoryTemplatesAsTree = async (moduleTemplateId: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/category/tree/${moduleTemplateId}`);
        return res.data;
    };

    const createProjectSGModuleTemplate = async (project: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/${handlerEndpoint}`, project);
        return res.data;
    };

    const deleteProjectSGModuleTemplate = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res.data;
    };

    
    const updateProjectSGModuleTemplate = async (project: any): Promise<any> => {
        const res = await axios.put(`${apiUrl}/${handlerEndpoint}`, project);
        return res.data;
    };

    const updateProjectSGModuleTemplateCategories = async (payload: any): Promise<any> => {
        const res = await axios.put(`${apiUrl}/${handlerEndpoint}/categories`, payload);
        return res.data;
    };

    return {
        getAllProjectSGPartnerModuleTemplate,
        getAllProjectSGDefaultModuleTemplate,
        getProjectSGCategoryTemplatesAsTree,
        getProjectSGModuleTemplate,
        getProjectSGModuleTemplateSummaryById,
        createProjectSGModuleTemplate,
        deleteProjectSGModuleTemplate,
        updateProjectSGModuleTemplate,
        updateProjectSGModuleTemplateCategories
    };
};
